import React from 'react';

import { CommonMessage } from '@frontend/lang';
import { IUser } from '@frontend/user/types';
import { FormattedMessage } from 'react-intl';
import { UserInterfaceProps } from '../types/user-interface';
import useUsersList from './contact-list.controller';

export interface ContactListProps extends UserInterfaceProps {
    onClick: (contact: IUser) => void;
}

export const ContactList = (props: ContactListProps) => {
    const viewProps = useUsersList(props);

    return (
        <div>
            <div className="d-flex justify-content-center">
                <h3>
                    <FormattedMessage
                        id='contact-list.select-receiver'
                        defaultMessage='Select a receiver'
                    />
                </h3>
            </div>
            <ul className='list-group w-100 m-1'>
                <li className='list-group-item list-group-item-primary'>
                    {CommonMessage.OBJECTS.CONTACT.PLURAL}
                </li>
                {viewProps.users.map((user) => (
                    <li
                        className='list-group-item list-group-item'
                        onClick={() => props.onClick(user)}
                        key={user.id}>
                        <span className='d-flex flex-row justify-content-between'>
                            <span className='d-flex flex-row align-items-center'>
                                {user.first_name} {user.last_name}
                            </span>
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
};
